// Maps card_id → visual notification metadata for manager card events.
// category drives which treatment the GameNotificationStack applies:
//   auto_at_bat    — card completes an AB without a pitch (sky)
//   runner_advance — card moves baserunners without a pitch (amber)
//   negation       — card reverses a result that already resolved (red)
//   roll_override  — card changes dice rules for the next pitch; shown as a
//                    persistent badge inside PitchingPhase, NOT in the notif stack
//   modifier       — card sets an ongoing stat bonus; shown as a lightweight
//                    Sonner toast, NOT in the notif stack

export const CARD_BANNER_MAP = {
  // Auto at-bat (complete AB without a pitch)
  take_the_walk:     { category: "auto_at_bat",    icon: "🚶", accent: "sky",    dismissMs: 2800 },
  bunt_instrument:   { category: "auto_at_bat",    icon: "🪃", accent: "sky",    dismissMs: 2800 },
  bogo_walk:         { category: "auto_at_bat",    icon: "2️⃣",  accent: "sky",    dismissMs: 2500 },

  // Runner advance (move runners without a pitch)
  hot_wheels:        { category: "runner_advance", icon: "🏃", accent: "amber",  dismissMs: 2500 },
  balk:              { category: "runner_advance", icon: "✋", accent: "amber",  dismissMs: 2500 },
  free_base:         { category: "runner_advance", icon: "➡️",  accent: "amber",  dismissMs: 2200 },

  // Negation (reverse a result)
  pine_tar:          { category: "negation",       icon: "❌", accent: "red",    dismissMs: 3500 },
  foul_play:         { category: "negation",       icon: "❌", accent: "red",    dismissMs: 3500 },
  frame_job:         { category: "negation",       icon: "🖼️", accent: "red",    dismissMs: 3000 },
  old_dog:           { category: "negation",       icon: "🐕", accent: "red",    dismissMs: 2500 },

  // Roll override — NOT in notification stack; handled by PitchingPhase badge
  derby_swing:       { category: "roll_override",  icon: "🎲", accent: "violet", dismissMs: null },
  all_or_nothing:    { category: "roll_override",  icon: "💥", accent: "violet", dismissMs: null },

  // Modifier — lightweight Sonner toast only
  plunk_them:        { category: "modifier",       icon: "🎯", accent: "slate",  dismissMs: 2000 },
  tensions_high:     { category: "modifier",       icon: "⚡", accent: "slate",  dismissMs: 2000 },
  charge_the_mound:  { category: "modifier",       icon: "⚡", accent: "slate",  dismissMs: 2000 },
  lineup_protection: { category: "modifier",       icon: "🛡️", accent: "slate",  dismissMs: 2000 },
  bench_clearing:    { category: "modifier",       icon: "🛡️", accent: "slate",  dismissMs: 2000 },
  shutdown_inning:   { category: "modifier",       icon: "🔒", accent: "slate",  dismissMs: 2000 },
  call_the_bullpen:  { category: "modifier",       icon: "📞", accent: "slate",  dismissMs: 2000 },
};
